/**
 * Shared patient display label.
 * Fallback order: Patient ID — First Last | Patient ID | First Last | Patient record #<id>
 */
export const getPatientDisplayName = (patient) => {
    if (!patient) return "N/A";

    const identifier = patient.patient_identifier?.trim();
    const firstName = patient.first_name?.trim() || "";
    const lastName = patient.last_name?.trim() || "";
    const fullName = `${firstName} ${lastName}`.trim();

    if (identifier && fullName) return `${identifier} — ${fullName}`;
    if (identifier) return identifier;
    if (fullName) return fullName;
    if (patient.id !== undefined && patient.id !== null) return `Patient record #${patient.id}`;
    return "N/A";
};

export const normalizePatientRowForUpload = (row) => ({
    ...row,
    patient_identifier: row.patient_identifier?.trim() || null,
    first_name: row.first_name?.trim() || null,
    last_name: row.last_name?.trim() || null,
    birth_date: row.birth_date
        ? typeof row.birth_date === "string"
            ? row.birth_date.substring(0, 10)
            : row.birth_date.format
              ? row.birth_date.format("YYYY-MM-DD")
              : null
        : null
});
